import { render, staticRenderFns } from "./MessageHistoryItem.vue?vue&type=template&id=0f9a6978&scoped=true"
import script from "./MessageHistoryItem.vue?vue&type=script&lang=js"
export * from "./MessageHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./MessageHistoryItem.vue?vue&type=style&index=0&id=0f9a6978&prod&lang=scss"
import style1 from "./MessageHistoryItem.vue?vue&type=style&index=1&id=0f9a6978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a6978",
  null
  
)

export default component.exports